// User Agent Protection Utility
// This file provides protection against userAgent-related errors

let userAgentProtected = false;

export const protectUserAgent = () => {
  if (userAgentProtected) return;
  try {
    const originalUserAgent = navigator.userAgent;
    Object.defineProperty(navigator, 'userAgent', {
      get: function() {
        return originalUserAgent || '';
      },
      configurable: true
    });
    userAgentProtected = true;
  } catch (error) {
    console.warn('UserAgent protection failed:', error.message);
  }
};

export const handleUserAgentError = (error) => {
  const userAgentErrorPatterns = [
    /useragent/i,
    /navigator/i,
    /user-agent/i
  ];
  return userAgentErrorPatterns.some(pattern => 
    pattern.test(error.message || '')
  );
};

// Safari-specific utilities
export const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const isSafariMobile = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent);
};

export const isSafariDesktop = () => {
  return isSafari() && !isSafariMobile();
};

export const setSafariIframeIssues = (hasIssues) => {
  if (hasIssues) {
    localStorage.setItem('safariIframeIssues', 'true');
  } else {
    localStorage.removeItem('safariIframeIssues');
  }
};

export const hasSafariIframeIssues = () => {
  return localStorage.getItem('safariIframeIssues') === 'true';
};

export const clearSafariIframeIssues = () => {
  localStorage.removeItem('safariIframeIssues');
}; 